import { ReactNode } from 'react';

export const StatusBanner = ({
  accountTypeSection,
  serverError,
  showRefreshingNotice,
}: {
  accountTypeSection: ReactNode;
  serverError: string | null;
  /** Only after the first load; avoids a flash on hard refresh / first mount */
  showRefreshingNotice: boolean;
}) => (
  <>
    {accountTypeSection}
    {serverError && <div className='rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700'>{serverError}</div>}
    {showRefreshingNotice && (
      <div className='rounded-xl border border-[#E8EAF0] bg-white px-4 py-3 text-sm text-[#6B7285]'>Refreshing dashboard...</div>
    )}
  </>
);
